export enum SituacaoParcelaPosVencimento {
  ParcelaEmAtraso = 'Parcela em atraso',
  ParcelaVencidaDuranteFeriado = 'Parcela vencida durante feriado',
  ParcelaEmDia = 'Parcela em dia'
}
